import getTT from '../getTT';
import h5 from './h5'

export default {
  sudo(isH5) {
    return new Promise((resolve, rejcet) => {
      getTT(TT => {
        TT.getUserInfo(userInfo => {
          if (userInfo.uid) {
            return resolve()
          }

          if (isH5) {
            // h5 跳转登录
            return h5.login()
          }

          TT.login.login()
          TT.login.on('loginClose', () => rejcet("取消登录"))
          TT.login.on('loginSuccess', () => resolve())
        })
      })
    });
  }
}